import EmptyState from '@components/EmptyState'
import React from 'react'

const LiveCoachingLocked: React.FC = () => (
  <EmptyState
    heading="Complete 2 lessons to unlock your live coaching session."
    img="/images/locked.svg"
    linkUrl="/learning-path"
    btnTxt="Go to my Learning Path"
    top="md"
  />
)

export default LiveCoachingLocked
